<template lang="jade">
  header.Form__header
    {{{ title }}}
</template>

<script>
  export default {
    data () {
      return {
        title: ''
      }
    },
    props: ['fdata'],
    ready () {
      this.title = `<h${this.fdata.tier} class="Form__title">${this.fdata.value}</h${this.fdata.tier}>`
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?2873e8f6